/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "enzymeFind"
      }), "(", _jsx(_components.code, {
        children: "enzymeFind"
      }), ")"]
    }), "\n", _jsx(_components.p, {
      children: "| v4"
    }), "\n", _jsx(_components.p, {
      children: "一种在 enzyme 封装纸内查找特定样式组件实例的便捷方法。"
    }), "\n", _jsx(_components.p, {
      children: "¥A convenience method for finding instances of a particular styled component within an enzyme wrapper."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { mount } from 'enzyme'\nimport styled from 'styled-components'\nimport { enzymeFind } from 'styled-components/test-utils'\n\nconst Foo = styled.div`\n  color: red;\n`\n\nconst wrapper = mount(\n  <div>\n    <Foo>bar</Foo>\n  </div>\n)\n\nenzymeFind(wrapper, Foo)\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
